import "./components/index";

// All your component and block imports remain the same
import { pageTransition } from "./components/page-transition.js";
import { aboutVideoPop } from "./components/about-video.js";
import initCursorToolTip from "./components/cursor-tooltip.js";
import initAddToCartToast from "./pages/woocommerce-toast.js";
import initSingleCareer from "./pages/single-career.js";
import { initEventFilter } from "./pages/event-archive.js";
import {
  initProductGallery,
  initAddToCartQty,
  initSingleProductSwiper,
} from "./pages/single-product.js";

document.addEventListener("DOMContentLoaded", () => {
  const bodyClasses = document.body.classList;

  // Global scripts
  pageTransition();
  initCursorToolTip();
  aboutVideoPop();

  // Scripts for specific pages
  if (bodyClasses.contains("single-product")) {
    initProductGallery();
    initAddToCartQty();
    initSingleProductSwiper();
    initAddToCartToast();
  }

  if (bodyClasses.contains("single-career")) {
    initSingleCareer();
  }

  if (bodyClasses.contains("post-type-archive-event")) {
    initEventFilter();
  }

  if (
    bodyClasses.contains("home") ||
    bodyClasses.contains("shop") ||
    bodyClasses.contains("product-category")
  ) {
    initAddToCartToast();
  }

  // Initialize Contact Form 7 if it exists
  if (window.wpcf7 && typeof window.wpcf7.init === "function") {
    document.querySelectorAll(".wpcf7 form").forEach((formEl) => {
      window.wpcf7.init(formEl);
    });
  }
});
